export const APP_NAME = "Credtics";
export const APP_EMAIL = "sales@credtics.com";
export const APP_PHONE = "(+256) 757 712 667";
export const APP_URL = "https://app.credtics.com/";
export const BLOG_URL = "https://medium.com/feed/@credtics.com";
export const CORS_URL = "https://api.codetabs.com/v1/proxy?quest=";
export const PROXY_URL = "https://api.rss2json.com/v1/api.json?rss_url=";
export const REGISTER_URL = APP_URL + "register";
export const EMAIL_URL = `mailto:${APP_EMAIL}`;
export const PHONE_URL = `tel:${APP_PHONE}`;
